const ProductAddedToCartModalStyle = {
  MODAL: 'MODAL',
  POPOVER: 'POPOVER'
};

export default ProductAddedToCartModalStyle;



// WEBPACK FOOTER //
// ./src/types/ProductAddedToCartModalStyle.js